<template>
  <div>
    <v-row class="mx-2">
      <v-col md="6" cols="12" class="my-auto">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            v-model="userInfo.nome"
            color="primary"
            label="Nome"
            prepend-icon="mdi-card-account-details"
            :error-messages="errors"
            :loading="loading"
          />
        </validation-provider>
      </v-col>
      <v-col id="col-mpc" md="6" cols="12" class="pt-1">
        <v-card-text class="pt-0">
          <label id="mpc">Perfis Associados</label>
          <v-chip-group show-arrows center-active>
            <v-chip v-for="(perfil, i) in userInfo.perfis" :key="i" color="#a2a8aa" text-color="white">
              <v-icon left>mdi-label</v-icon>
              {{ perfil }}
            </v-chip>
          </v-chip-group>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-col cols="6">
        <v-text-field
          color="primary"
          label="Login"
          prepend-icon="mdi-account"
          :value="userInfo.login"
          :loading="loading"
          readonly
        />
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="userInfo.tipo" color="primary" label="Tipo" prepend-icon="mdi-tag" :loading="loading" />
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-col :cols="'6'">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            v-model="userInfo.email"
            color="primary"
            label="Email"
            prepend-icon="mdi-email"
            :error-messages="errors"
            :loading="loading"
          />
        </validation-provider>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="password"
          :type="tipoInput"
          color="primary"
          label="Senha"
          prepend-icon="mdi-lock"
          :loading="loading"
        >
          <template v-slot:append>
            <v-icon @click="visualizarSenha()">mdi-eye</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-col md="4" cols="6">
        <v-text-field v-model="userInfo.cargo" color="primary" label="Cargo" prepend-icon="mdi-certificate" :loading="loading" />
      </v-col>
      <v-col md="4" cols="6">
        <v-text-field
          v-model="userInfo.diretoria"
          color="primary"
          label="Diretoria"
          prepend-icon="mdi-account-tie"
          :loading="loading"
        />
      </v-col>
      <v-col md="4" cols="12">
        <v-text-field
          v-model="userInfo.area_executiva"
          color="primary"
          label="Area Executiva"
          prepend-icon="mdi-tie"
          :loading="loading"
        />
      </v-col>
    </v-row>
    <v-col class="shrink text-right">
      <v-btn color="accent" outlined @click="updateUsuario()">Salvar</v-btn>
    </v-col>
  </div>
</template>

<script>
  import UsuariosService from '@/services/UsuariosService';

  export default {
    name: 'PerfilUsuarioDetalhes',
    props: {
      userInfoProp: {
        type: Object,
        default: () => {}
      },
      loading: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        tipoInput: 'password',
        password: '',
        userInfo: {}
      };
    },
    methods: {
      visualizarSenha() {
        this.tipoInput === 'password' ? (this.tipoInput = 'text') : (this.tipoInput = 'password');
      },
      updateUsuario() {
        const user = {
          nome: this.userInfo.nome,
          email: this.userInfo.email,
          tipo: this.userInfo.tipo,
          cargo: this.userInfo.cargo,
          diretoria: this.userInfo.diretoria,
          area_executiva: this.userInfo.area_executiva
        };

        if (this.password !== '') {
          this.$set(user, 'senha', this.password);
        }

        UsuariosService.updateUsuario(user)
          .then(() => {
            this.$toast.success('Dados do usuário atualizados com sucesso.', '', {
              position: 'topRight'
            });
          })
          .catch((error) => {
            this.$toast.error('Ocorreu um erro ao salvar os dados do usuário.', '', {
              position: 'topRight'
            });
            console.error('Erro:', error);
          });
      }
    },
    watch: {
      userInfoProp(val) {
        this.userInfo = val;
      }
    }
  };
</script>

<style>
  #mpc {
    margin-left: 19px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
  }

  #col-mpc .v-item-group {
    margin-left: 17px;
  }

  #col-mpc .v-slide-group--has-affixes {
    margin-left: -35px !important;
    width: 115% !important;
    max-width: 115% !important;
  }
</style>
